// Generated by npm run git-info — do not edit by hand
export const commit = "c98be55";
